import React from 'react';
import cn from 'classnames';
import isMobile from '../../../../utils/isMobile.js';

export const MessageContentWrapper = ({
  show,
  systemMessages,
  wrapperDiv,
  onCopy,
}) => {
  if (!(isMobile() && show)) return null;

  const buttonBoxClassName = cn('cu-ui-message-content__wrapper__button-box', [
    wrapperDiv && wrapperDiv.offsetTop < 40 ? 'on-bottom' : 'on-top'
  ]);

  return (
    <div className='cu-ui-message-content__wrapper'>
      <div className='cu-ui-message-content__wrapper__inner'>
        <div className={buttonBoxClassName}>
          <button className='cu-ui-message-content__wrapper__button'
            onClick={onCopy}
          >
            { systemMessages.copy }
          </button>
        </div>
      </div>
    </div>
  );
};
